export const geraMascaraCNPJ = (pcnpj) => {
  let cnpj = pcnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  return cnpj;
}

export const tiraMascaraCNPJ = (pcnpj) => {
  return pcnpj.replace(/[^0-9]/g, '');
}